import { format, addDays, addWeeks, startOfDay } from 'date-fns';

/**
 * Expand a recurring expense template into date strings (yyyy-MM-dd) that fall
 * within [rangeStart, rangeEnd]. Supports monthly (dayOfMonth), weekly and
 * biweekly (dayOfWeek + biweeklyStartDate anchor) frequencies.
 *
 * Pure function shared by web and mobile so materialization stays in sync.
 */
export const expandRecurringExpenseOccurrences = (recurringExpense, rangeStart, rangeEnd) => {
  const dates = [];
  const { frequency, dayOfMonth, dayOfWeek, biweeklyStartDate } = recurringExpense;

  if (frequency === 'monthly') {
    const start = new Date(rangeStart);
    const end = new Date(rangeEnd);
    let current = new Date(start.getFullYear(), start.getMonth(), dayOfMonth);
    if (current < start) {
      current = new Date(current.getFullYear(), current.getMonth() + 1, dayOfMonth);
    }
    while (current <= end) {
      // Skip months where dayOfMonth doesn't exist (e.g., Feb 31 rolls over)
      if (current.getDate() === dayOfMonth) {
        dates.push(format(current, 'yyyy-MM-dd'));
      }
      current = new Date(current.getFullYear(), current.getMonth() + 1, dayOfMonth);
    }
  } else if (frequency === 'weekly') {
    let current = startOfDay(new Date(rangeStart));
    const end = startOfDay(new Date(rangeEnd));
    while (current <= end) {
      if (current.getDay() === dayOfWeek) {
        dates.push(format(current, 'yyyy-MM-dd'));
      }
      current = addDays(current, 1);
    }
  } else if (frequency === 'biweekly') {
    if (!biweeklyStartDate) return dates;
    const anchor = startOfDay(new Date(biweeklyStartDate + 'T00:00:00'));
    let current = new Date(anchor);
    const start = startOfDay(new Date(rangeStart));
    const end = startOfDay(new Date(rangeEnd));
    while (current > start) current = addWeeks(current, -2);
    while (current < start) current = addWeeks(current, 2);
    while (current <= end) {
      dates.push(format(current, 'yyyy-MM-dd'));
      current = addWeeks(current, 2);
    }
  }

  return dates;
};
